// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"833028b2","1481":"cf0213a2","5861":"9a03586b","7212":"fde7183c"}[chunkId] + ".chunk.css";
};